export { default } from './SpecPagesView';



// WEBPACK FOOTER //
// ./src/components/SpecialPages/SpecPagesView/index.js